// React Router
import { Navigate } from 'react-router-dom'

// Layouts & Components
import AdminLayout from '@/layout/AdminLayout'
import LoginLayout from '@/layout/LoginLayout'
import ProtectedRoute from '@/components/auth/ProtectedRoute'

// Pages
import LoginPage from '@/pages/login/LoginPage'
// import LookUpPage from "@/pages/lookup/LookUpPage.tsx";

// Route Modules
import { adminRoutes } from './routes/adminRoutes'
import { memberRoutes } from './routes/memberRoutes'
import { contentRoutes } from './routes/contentRoutes'
import { eventRoutes } from './routes/eventRoutes'
import { csRoutes } from './routes/csRoutes'
import { communityRoutes } from './routes/communityRoutes'
import { recordRoutes } from './routes/recordRoutes'
import { screenRoutes } from './routes/screenRoutes'
import { policyRoutes } from './routes/policyRoutes'
import { settlementRoutes } from './routes/settlementRoutes'
import { tagRoutes } from './routes/tagRoutes'
import { jobRoutes } from './routes/jobRoutes'

// Types
import type { RouteWithMeta } from './types'

// 라우트 정의 (메타 정보를 포함하여 Sidebar와 Breadcrumb에서 사용)
// 타입은 types.ts에서 import
export const routes: RouteWithMeta[] = [
  // 로그인
  {
    path: '/login',
    element: <LoginLayout />,
    children: [
      {
        path: '',
        element: <LoginPage />,
      }
    ]
  },

  // 관리자 페이지 (인증 필요)
  {
    path: '/',
    element: <ProtectedRoute />,
    children: [
      {
        path: '',
        element: <AdminLayout />,
        children: [
          // 메인 페이지 (/) - 관리자 페이지로 리다이렉트
          {
            element: <Navigate to="/admin" replace />
          },

          //통계
          //관리자 관리
          ...adminRoutes,
          // 사용자 관리
          memberRoutes,
          // 콘텐츠 관리
          contentRoutes,
          // 이벤트 관리
          eventRoutes,
          // 유저지원 관리
          csRoutes,
          // 커뮤니티 관리
          communityRoutes,
          // 결제 및 구매
          recordRoutes,
          // 화면
          screenRoutes,
          // 정책
          policyRoutes,
          //버전관리
          // 정산
          settlementRoutes,
          // 태그
          ...tagRoutes,
          //코드
          // {
          //   path: 'lookup',
          //   element: <LookUpPage/>,
          //   meta: {
          //     label: '코드',
          //     showInMenu: true,
          //     icon: ''
          //   },
          // },

          //스케쥴러
          ...jobRoutes,
        ]
      }
    ]
  },

  // 404
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]